import { rsaEncryptByPubkey, aesEncryptReplaceBlank, aesDecrypt } from './crypto'

export { getRandomString } from './random-string'
export { observerImage, unobserverImage } from './elm_observer'
export { getConfig, isEncodeUrl, downloadEncodeImg } from './img'

// const useEncrypt = process.env.ENV !== 'develpment'
const useEncrypt = true

/**
 * @description api参数加密
 * @param data 需要加密的数据
 * @param params :{key,url}
 * @returns
 */
export function encryptData(data, params = {}) {
  if (!useEncrypt) return JSON.stringify(data)
  let str_data

  str_data = JSON.stringify(data)

  const key = params.key
  const en_data = aesEncryptReplaceBlank(key, str_data)
  if (!en_data) return
  const en_key = rsaEncryptByPubkey(getPbkey(), key)
  const r_data = {
    data: en_data,
    key: en_key
  }
  // console.log('加密参数---',en_key, ',', en_data, ',', key );
  return r_data
}

/**
 * api返回数据解密
 * @param data 需要解密的数据
 * @param params :{key,url}
 */
export function decryptData(data, params = {}) {
  if (!useEncrypt) return data
  const data_str = aesDecrypt(params.key, data)
  let data_json
  try {
    data_json = JSON.parse(data_str)
  } catch (error) {
    return data_str
  }
  return data_json
}

// /////////////////////////////////辅助函数////////////////////////////////////////
var _pbkey = undefined
// 获取公钥
function getPbkey() {
  if (!_pbkey) {
    // _pbkey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDGdjkX8+4FvFSBYX7XlgFFrx9efthnCaml+FYf7Um8DYx1deD6Ws06j7dzmyicyUrdATJrNhkGSb0KKklC3rVuJnO/3Vuu0CLQ5ZBjhxHfoHcBMz6BDkqWdHHCNwMfTU0SUO16MU3M06jKLWLR9CMg6yDxX9L2Vmuz73n97+88DwIDAQAB'
    _pbkey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC03Ia/id+UqxK126h+luGshAP4oL2guu5wZCSNGuNbPMATuOd5/8/YcLDukDz5LtxdabH+tsX4JX5vM2Wl6ty4eyiWIpw89a0nBL4firSgHe0w2iZ2FCz2XnGhnwNDTlAdUi2cghzjMHOGJt49/ZoUqi3G/8O6QlIqCYwEJg5a4QIDAQAB'
  }
  return _pbkey
}
